"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSectionMutationOptions = exports.createSectionMutation = void 0;
const client_1 = require("@apollo/client");
const sectionAndRecipeName_1 = require("../fragments/sectionAndRecipeName");
const sectionsByCookbookId_1 = require("../queries/sectionsByCookbookId");
exports.createSectionMutation = client_1.gql `
  mutation CreateSection($input: CreateSectionInput!) {
    createSection(input: $input) {
      __typename
      errors {
        path
        message
      }
      section {
        ...justSection
      }
    }
  }

  ${sectionAndRecipeName_1.justSectionFragment}
`;
exports.createSectionMutationOptions = (variables) => ({
    variables,
    update: (store, { data: dataResponse }) => {
        if (!dataResponse) {
            return;
        }
        const { createSection: { section }, } = dataResponse;
        const data = store.readQuery({
            query: sectionsByCookbookId_1.sectionsByCookbookIdQuery,
            variables: { cookbookId: variables.input.cookbookId },
        });
        if (data && section) {
            store.writeQuery({
                query: sectionsByCookbookId_1.sectionsByCookbookIdQuery,
                variables: { cookbookId: variables.input.cookbookId },
                data: {
                    __typename: "Query",
                    sectionsByCookbookId: [...data.sectionsByCookbookId, section],
                },
            });
        }
    },
});
//# sourceMappingURL=createSection.js.map